/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react'
import { useThrottle } from './useThrottle'

/**
 * 要素の位置を取得する
 * @see https://zenn.dev/catnose99/articles/0f0bb01ee6a940
 *
 * @param ref 調べたい要素のRefObject
 * @returns viewportTop: 現在表示されているビューポートの上からの距離、pageOffsetTop: スクロール関係なくページ上端からの距離
 */
export const useOffsetTop = (ref?: React.RefObject<HTMLElement>) => {
  const [viewportTop, setViewportTop] = useState<number | undefined>(undefined)
  const [pageOffsetTop, setPageOffsetTop] = useState<number | undefined>(
    undefined
  )

  const handler = useThrottle(() => {
    if (!ref?.current) return

    const clientRect = ref.current.getBoundingClientRect()
    setViewportTop(clientRect.top)
    const newPageOffsetTop = clientRect.top + window.pageYOffset
    setPageOffsetTop(newPageOffsetTop)
  }, 100) // レンダリング負荷軽減のため、100msに一度実行

  useEffect(() => {
    if (!ref?.current) return

    // マウント時にも実行
    handler()
    window.addEventListener('scroll', handler)

    // アンマウント時にイベントリスナーを解除
    return () => window.removeEventListener('scroll', handler)
  }, [handler])

  return { viewportTop, pageOffsetTop }
}
